import * as React from "react";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { Form } from "../../../../controls/useForm";
import { Grid } from "@material-ui/core";
import Controls from "../../../../controls/Controls";
import Box from "@mui/material/Box";
import PaymentOutlinedIcon from "@material-ui/icons/PaymentOutlined";
import { Typography } from "@material-ui/core";
import { borderRadius } from "@mui/system";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 100,
  p: 4,
};

export default function Repayments() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Controls.Button
        text="Repayments"
        variant="outlined"
        onClick={handleOpen}
        startIcon={<PaymentOutlinedIcon />}
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Form sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Add Repayment
            </Typography>
            <hr />
            <Grid container>
              <Grid item xs={6}>
                <Controls.Input
                  label="Customer Name"
                  name="phoneNumber"
                  value=""
                />
                <Controls.Input label="Sales ID" name="sales" value="" />
                <Controls.Input
                  label="Payment Plan ID"
                  name="payment"
                  value=""
                />
                <Controls.Input
                  label="Sales Amount"
                  name="salesAmount"
                  value=""
                />
                <Controls.Input label="Frequency" name="frequency" value="" />
              </Grid>
              <Grid item xs={6}>
                <Controls.Input
                  label="Financing Charge"
                  name="financing"
                  value=""
                />
                <Controls.Input
                  label="Total Amount Payable Payable"
                  name="amountPayable"
                  value=""
                />
                <Controls.Input label="Tenor" name="tenor" value="" />
                <Controls.Input label="Repayment" name="repayment" value="" />
                <Controls.Input
                  label="Outstanding"
                  name="outstanding"
                  value=""
                />
              </Grid>
            </Grid>
            <div className="text-center mt-2 pt-3">
              <Button className="w-50" variant='contained' style={{ backgroundColor: "#3f51b5" }}>Submit</Button>
            </div>
          </Form>
        </Box>
      </Modal>
    </div>
  );
}
